import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcFileInvoiceDollar, IcPdf, IcAt, IcExcel, IcFileAlt, IcDollar, FaIcon } from "../../Icons";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';

function EstadoCuenta() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;
  const URL_CARGOS  = process.env.REACT_APP_URL_CARGOS;
  const URL_ABONOS  = process.env.REACT_APP_URL_ABONOS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [mailTo, setMailTo] = useState("");
  const [nombreCliente, setNombreCliente] = useState([]);
  const [saldo, setSaldo] = useState(0);
    const [selectedEmpresa, setSelectedEmpresa] = useState("ExceptoSistemify");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalMail2, setModalMail2] = useState(false);
  const toggleMail2 = () => setModalMail2(!modalMail2);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalCargos, setModalCargos] = useState(false);
  const toggleCargos = () => setModalCargos(!modalCargos);

  // ── Capturar Pago ──────────────────────────────────────────────────────────
  const [modalPago,     setModalPago]     = useState(false);
  const togglePago = () => setModalPago(!modalPago);
  const [pagoInputFields, setPagoInputFields] = useState([]);
  const [pagoTotal,     setPagoTotal]     = useState(0);
  const [pagoFecha,     setPagoFecha]     = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [pagoFormaPago, setPagoFormaPago] = useState("Efectivo");
  const [pagoConcepto,  setPagoConcepto]  = useState("Abono");
  const [pagoClienteId, setPagoClienteId] = useState("");
  const [pagoLoading,   setPagoLoading]   = useState(false);
  const [modalRelacionado, setModalRelacionado] = useState(false);
  const toggleRelacionado = () => setModalRelacionado(!modalRelacionado);
  const [saldoFiltroRel, setSaldoFiltroRel] = useState("Pendientes");

  const [activo, setActivo] = useState("");
  const [estadoPago, setEstadoPago] = useState("Pendientes");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [movimientos, setMovimientos] = useState([])
  const [idCliente, setIdCliente] = useState("");
  const [saldoInicial, setSaldoInicial] = useState(0);

  const [cargos, setCargos] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;


  useMemo(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        // Array para pagination
        let arrayTabla = allClientes
          .sort((a, b) => (a.saldo > b.saldo ? 1 : -1))
          .map((a) => {
              return {
                _id: a._id,
                activo: a.is_active,
                nombre_comercial: a.nombre_comercial,
                razon_social: a.razon_social,
                cargos: parseFloat(a.cargos),
                abonos: parseFloat(a.abonos),
                saldo: parseFloat(a.saldo),
                cliente:  a.nombre_comercial,
                ramo: a.ramo,
                empresa: a.empresa,
                contacto: a.contacto
              }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setClientes(allClientes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
      });
     
      let SI = movimientos.map((c)=>{
        if(selectedFechaInicio){
          if(
          (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)){
            return (
                c.cargo - c.abono
            )
          }
        }
        else{
          return 0
        }
      }).filter(function (el) {
        return el != null;
      });

      let TC = SI.reduce((t, total, index) => t + total, 0);

      setSaldoInicial(TC)

  }, [user, movimientos, selectedFechaInicio]);


  const ListaClientes = comments.sort((a, b) =>
    a.saldo > b.saldo ? 1 : -1
  );
let TotalSaldo = 0
function PDFTabla() {
  let TotalSaldo = 0;

  // 🔹 Base
  let filteredComments = comments;

  // 🔹 Filtro por estado de pago
  if (estadoPago === "Pendientes") {
    filteredComments = filteredComments.filter((e) => e.saldo > 0);
  } else if (estadoPago === "Liquidados") {
    filteredComments = filteredComments.filter((e) => e.saldo === 0);
  }

  // 🔹 Búsqueda por texto
  filteredComments = filteredComments.filter((comment) =>
    comment.nombre_comercial.toLowerCase().includes(search.toLowerCase()) ||
    comment.ramo.toLowerCase().includes(search.toLowerCase()) ||
    comment.contacto.toLowerCase().includes(search.toLowerCase()) ||
    comment.cargos.toString().includes(search) ||
    comment.abonos.toString().includes(search) ||
    comment.saldo.toString().includes(search)
  );

  // 🔹 Filtro por empresa + activo
  filteredComments = filteredComments.filter((a) => {
    const pasaEmpresa =
      selectedEmpresa === "" ||
      (selectedEmpresa === "ExceptoSistemify"
        ? a.empresa !== "Sistemify"
        : a.empresa === selectedEmpresa);

    const pasaActivo = activo == 0 || activo == a.activo;

    return pasaEmpresa && pasaActivo;
  });

  // 🔹 Orden
  filteredComments.sort((a, b) => (a.saldo > b.saldo ? 1 : -1));

  // 🔹 Construcción de filas PDF
  const dataPDF = filteredComments.map((a) => {
    TotalSaldo += Number(a.saldo) || 0;

    return [
      a.nombre_comercial,
      a.contacto,
      "$" + new Intl.NumberFormat("en-US").format(a.saldo),
    ];
  });

  // 🔹 PDF
  const doc = new jsPDF();
  const startY = pdfHeader(doc, "Saldos Pendientes");

  doc.autoTable({
    ...pdfTableStyles(),
    head: [["Cliente", "Contacto", "Saldo"]],
    body: dataPDF,
    startY,
    foot: [
      [
        "",
        "Total",
        "$" + new Intl.NumberFormat("en-US").format(TotalSaldo),
      ],
    ],
    showFoot: "lastPage",
  });

  pdfFooter(doc);
  doc.save(`Saldos.pdf`);
}

function excel() {
  const dataExcel = ListaClientes.map((a) => {
    const coincideActivo = activo === "" || activo === a.is_active;

    const coincideEmpresa =
      selectedEmpresa === "" ||
      (selectedEmpresa === "ExceptoSistemify"
        ? a.empresa !== "Sistemify"
        : selectedEmpresa === a.empresa);

    const coincideEstadoPago =
      estadoPago === "" ||
      (estadoPago === "Pendientes" && a.saldo > 0) ||
      (estadoPago === "Liquidados" && a.saldo === 0);

    if (coincideActivo && coincideEstadoPago && coincideEmpresa) {
      return {
        Cliente: a.nombre_comercial,
        Cargos: a.cargos,
        Abonos: a.abonos,
        Saldo: a.saldo,
      };
    }
    return null;
  });

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  const option = {
    fileName: "EstadoCuenta",
    datas: [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: ["Cliente", "Cargos", "Abonos", "Saldo"],
        sheetHeader: ["Cliente", "Cargos", "Abonos", "Saldo"],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
     const data = ListaClientes.map((a) => {
    const coincideActivo = activo === "" || activo === a.is_active;
    const coincideEstadoPago =
      estadoPago === "" ||
      (estadoPago === "Pendientes" && a.saldo > 0) ||
      (estadoPago === "Liquidados" && a.saldo === 0);

    if (coincideActivo && coincideEstadoPago) {
      return [
        a.nombre_comercial,
        "$" + new Intl.NumberFormat("en-US").format(a.cargos),
        "$" + new Intl.NumberFormat("en-US").format(a.abonos),
        "$" + new Intl.NumberFormat("en-US").format(a.saldo),
      ];
    }
    return null;
  });

  const dataPDF = data.filter((el) => el !== null);

  // Calcular totales
  const totalCargos = ListaClientes.reduce((acc, a) => {
    const coincideActivo = activo === "" || activo === a.is_active;
    const coincideEstadoPago =
      estadoPago === "" ||
      (estadoPago === "Pendientes" && a.saldo > 0) ||
      (estadoPago === "Liquidados" && a.saldo === 0);

    return coincideActivo && coincideEstadoPago ? acc + a.cargos : acc;
  }, 0);

  const totalAbonos = ListaClientes.reduce((acc, a) => {
    const coincideActivo = activo === "" || activo === a.is_active;
    const coincideEstadoPago =
      estadoPago === "" ||
      (estadoPago === "Pendientes" && a.saldo > 0) ||
      (estadoPago === "Liquidados" && a.saldo === 0);

    return coincideActivo && coincideEstadoPago ? acc + a.abonos : acc;
  }, 0);

  const totalSaldo = ListaClientes.reduce((acc, a) => {
    const coincideActivo = activo === "" || activo === a.is_active;
    const coincideEmpresa = selectedEmpresa === "" || selectedEmpresa === a.empresa;
    const coincideEstadoPago =
      estadoPago === "" ||
      (estadoPago === "Pendientes" && a.saldo > 0) ||
      (estadoPago === "Liquidados" && a.saldo === 0);

    return coincideActivo && coincideEstadoPago && coincideEmpresa ? acc + a.saldo : acc;
  }, 0);

  const doc = new jsPDF("landscape");
  const startY = pdfHeader(doc, "Estado de Cuenta");

  // Tabla
  doc.autoTable({
    ...pdfTableStyles(),
    head: [["Cliente", "Cargos", "Abonos", "Saldo"]],
    body: dataPDF,
    startY,
    foot: [
      [
        "Totales",
        "$" + new Intl.NumberFormat("en-US").format(totalCargos),
        "$" + new Intl.NumberFormat("en-US").format(totalAbonos),
        "$" + new Intl.NumberFormat("en-US").format(totalSaldo),
      ],
    ],
    showFoot: "lastPage",
  });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: "EstadoCuenta.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("")
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  }



  const headers = [
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Ramo", field: "ramo", sortable: true },
    { name: "Cargos", field: "cargos", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Estado Cuenta", field: "acciones", sortable: false },
    { name: "Pago", field: "pago", sortable: false },
  ];

  const summaryStats = useMemo(() => {
    const fmtI    = (v) => "$" + new Intl.NumberFormat("en-US").format(Math.round(v || 0));
    const activos = comments.filter((c) => c.activo === "Si");
    const totalCargos = activos.reduce((s, c) => s + (Number(c.cargos) || 0), 0);
    const totalAbonos = activos.reduce((s, c) => s + (Number(c.abonos) || 0), 0);
    const totalSaldo  = activos.reduce((s, c) => s + (Number(c.saldo)  || 0), 0);
    const conDeuda    = activos.filter((c) => (Number(c.saldo) || 0) > 0).length;
    const cobPct      = totalCargos > 0 ? (totalAbonos / totalCargos * 100) : 0;
    return {
      clientes:    activos.length,
      conDeuda,
      totalCargos: fmtI(totalCargos),
      totalSaldo:  fmtI(totalSaldo),
      cobPct:      cobPct.toFixed(1),
      cobColor:    cobPct >= 80 ? "#10b981" : cobPct >= 50 ? "#f59e0b" : "#ef4444",
      cobBg:       cobPct >= 80 ? "#f0fdf4" : cobPct >= 50 ? "#fffbeb" : "#fff1f2",
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial.toLowerCase().includes(search.toLowerCase()) ||
          comment.contacto.toLowerCase().includes(search.toLowerCase()) ||
          comment.ramo.toLowerCase().includes(search.toLowerCase()) ||
          comment.cargos.toString().includes(search)||
          comment.abonos.toString().includes(search)||
          comment.saldo.toString().includes(search)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

if (estadoPago === "Pendientes") {
  computedComments = computedComments.filter((e) => e.saldo > 0);
} else if (estadoPago === "Liquidados") {
  computedComments = computedComments.filter((e) => e.saldo === 0);
}

    if (selectedEmpresa === "ExceptoSistemify") {
  computedComments = computedComments.filter(
    (e) => e.empresa !== "Sistemify"
  );
} else if (selectedEmpresa) {
  computedComments = computedComments.filter(
    (e) => e.empresa === selectedEmpresa
  );
}
    setTotalItems(computedComments.length);

//Sorting comments
if (
  sorting.field &&
  sorting.field != "cargos" &&
  sorting.field != "abonos" &&
  sorting.field != "saldo"
) {
  const reversed = sorting.order === "asc" ? 1 : -1;
  computedComments = computedComments.sort(
    (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
  );
}

if (
  sorting.field &&
  sorting.order === "asc" &&
  (sorting.field == "cargos" ||
    sorting.field == "abonos" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
  );
}

if (
  sorting.field &&
  sorting.order === "desc" &&
  (sorting.field == "cargos" ||
  sorting.field == "abonos" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
  );
}

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
    estadoPago,
    selectedEmpresa
  ]);

 async function jalaMov(id, cliente, saldo){
    await  axios
      .get(`${URL_ESTADO_CUENTA}/${id}`, {
        headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allVentas = response.data
      setMovimientos(allVentas);
      //
    })
    .catch((err) => {
    });
      setNombreCliente(cliente)
      setIdCliente(id)
      setSaldo(saldo)
      toggle()
  }

  async function jalaCargos(id, cliente, saldo){
    await  axios
      .get(`${URL_CARGOS}/cliente/${id}`, {
        headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allVentas = response.data
      setCargos(allVentas);
      //
    })
    .catch((err) => {
    });
      setNombreCliente(cliente)
      setIdCliente(id)
      setSaldo(saldo)
      toggleCargos()
  }

  // ── Abrir modal de captura de pago ────────────────────────────────────────
  async function abrirPago(id, cliente, saldoCliente) {
    setPagoLoading(true);
    setPagoClienteId(id);
    setNombreCliente(cliente);
    setSaldo(saldoCliente);
    setPagoTotal(0);
    setPagoFecha(moment(new Date()).format("YYYY-MM-DD"));
    setPagoFormaPago("Efectivo");
    setPagoConcepto("Abono");
    try {
      const res = await axios.get(`${URL_CARGOS}/cliente/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const fields = res.data
        .filter((c) => c.saldo > 0)
        .map((a) => ({
          id:            a._id,
          fecha:         a.fecha,
          total_general: a.importe,
          saldo:         a.saldo,
          abonos:        a.abonos,
          nota:          a.idCargo,
          importe:       0,
          observaciones: "NA",
        }));
      setPagoInputFields(fields);
    } catch (e) {}
    setPagoLoading(false);
    togglePago();
  }

  function handlePagoImporte(id, e) {
    const val = parseFloat(e.target.value) || 0;
    const updated = pagoInputFields.map((i) => {
      if (i.id === id) {
        if (val <= i.saldo || e.target.value === "") {
          return { ...i, importe: val };
        } else {
          Swal.fire({ icon: "error", title: "Oops...", text: "El pago excede el saldo" });
        }
      }
      return i;
    });
    setPagoInputFields(updated);
    setPagoTotal(updated.reduce((t, i) => t + (i.importe || 0), 0));
  }

  function handlePagoObs(id, e) {
    setPagoInputFields(pagoInputFields.map((i) =>
      i.id === id ? { ...i, observaciones: e.target.value } : i
    ));
  }

  function savePago() {
    const conImporte = pagoInputFields.filter((a) => a.importe > 0);
    if (!conImporte.length) {
      Swal.fire({ icon: "warning", title: "Sin importes", text: "Ingresa al menos un importe" });
      return;
    }
    Swal.fire({
      title: "¿Estás seguro?",
      text:  "Se registrará el abono",
      icon:  "warning",
      showCancelButton:    true,
      confirmButtonColor:  "#3085d6",
      cancelButtonColor:   "#d33",
      confirmButtonText:   "Sí, registrar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      let pending = conImporte.length;
      conImporte.forEach((a) => {
        axios
          .post(URL_ABONOS, {
            fecha:          pagoFecha,
            importe:        a.importe,
            clientes:       pagoClienteId,
            cargos:         a.id,
            formaPago:      pagoFormaPago,
            concepto:       pagoConcepto,
            comisionPagada: "No",
            observaciones:  a.observaciones,
            aplicado:       "No",
          }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
          .then(() => {
            axios.patch(`${URL_CARGOS}/${a.id}`,
              { saldo: a.saldo - a.importe, abonos: a.abonos + a.importe },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            );
            pending -= 1;
            if (pending === 0) {
              togglePago();
              Swal.fire("¡Listo!", "Pago registrado con éxito", "success");
              setTimeout(() => window.location.reload(), 1000);
            }
          })
          .catch(() => Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar" }));
      });
    });
  }

  // PDF Mail Excel Cliente
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0

  function PDFOC() {
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0
    const data = movimientos
      .map((a) => {
        if(
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)){
          totalCargosEdoCte = totalCargosEdoCte + a.cargo
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo
          saldoParcial = saldoParcial + a.cargo - a.abono
      const movLabel = a.movimiento;
      const cargos = a.cargo > 0 ? "$" + new Intl.NumberFormat("en-US").format(a.cargo) : "-";
      const abonos = a.abono > 0 ? "$" + new Intl.NumberFormat("en-US").format(a.abono) : "-";
      var saldoParcialFormato = "$" + new Intl.NumberFormat("en-US").format(saldoParcial);
      return [a.fecha, movLabel, cargos, abonos, saldoParcialFormato];
    }
  })
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Fecha", "Movimiento", "Cargos", "Abonos", "Saldo"]],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          { content: 'Saldo Anterior', colSpan: 2, styles: { halign: 'left' } },
          // "Saldo Anterior",
          "$" + new Intl.NumberFormat("en-US").format(saldoInicial),
        ],
        [
          "",
          "",
          { content: 'Cargos del Periodo', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          { content: 'Abonos del Periodo', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          { content: 'Saldo Actual', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
  }

  function emailFOC() {
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0
    const data = movimientos
    .map((a) => {
      if(
      (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)){
        totalCargosEdoCte = totalCargosEdoCte + a.cargo
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo
        saldoParcial = saldoParcial + a.cargo - a.abono
    const movLabel = a.movimiento;
    const cargos = a.cargo > 0 ? "$" + new Intl.NumberFormat("en-US").format(a.cargo) : "-";
    const abonos = a.abono > 0 ? "$" + new Intl.NumberFormat("en-US").format(a.abono) : "-";
    var saldoParcialFormato = "$" + new Intl.NumberFormat("en-US").format(saldoParcial);
    return [a.fecha, movLabel, cargos, abonos, saldoParcialFormato];
  }
})
  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });
  const doc = new jsPDF();
  const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente} — Desde ${selectedFechaInicio}`);
  doc.autoTable({
    ...pdfTableStyles(),
    head: [["Fecha", "Movimiento", "Cargos", "Abonos", "Saldo"]],
    body: dataPDFLimpia,
    startY,
    foot: [
      [
        "",
        "",
        { content: 'Saldo Anterior', colSpan: 2, styles: { halign: 'left' } },
        // "Saldo Anterior",
        "$" + new Intl.NumberFormat("en-US").format(saldoInicial),
      ],
      [
        "",
        "",
        { content: 'Cargos del Periodo', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(totalCargosEdoCte),
      ],
      [
        "",
        "",
        { content: 'Abonos del Periodo', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(totalAbonosEdoCte),
      ],
      [
        "",
        "",
        { content: 'Saldo Actual', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(saldoParcial),
      ],
    ],
    showFoot: "lastPage",
  });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreCliente}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreCliente}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail2();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("")
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  }

  function excelFOC() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Cargos: a.cargos,
      }}
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaCliente-${nombreCliente}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: ["Fecha", "Movimiento", "Numero", "Cargo", "Abono"] ,
        sheetHeader: ["Fecha", "Movimiento", "Numero", "Cargo", "Abono"] ,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  async function jalaMovRel(id, cliente, saldo, email) {
    await axios
      .get(`${URL_ESTADO_CUENTA}Relacionado/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
      });
    setNombreCliente(cliente);
    setIdCliente(id);
    setSaldo(saldo);
    setMailTo(email);
    toggleRelacionado();
  }

  function PDFOCRelacionado() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    if(saldoFiltroRel == "Pendientes"){
      const data = movimientos.map((a) => {
        if (a.saldo > 1) {
          totalCargosEdoCte = totalCargosEdoCte + a.cargo;
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
          saldoParcial = saldoParcial + a.cargo - a.abono;
          const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo);
          const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono);
          var saldoParcialFormato =
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial);
          return [
            a.fecha,
            a.descripcion,
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo - a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ];
        }
      });
      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });
      const doc = new jsPDF();
      const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
      doc.autoTable({
        ...pdfTableStyles(),
        head: [
          [
            "Fecha",
            "Descripcion",
            "Cargos",
            "Abonos",
            "Saldo",
            "Saldo Total",
          ],
        ],
        body: dataPDFLimpia,
        startY,
        foot: [
          [
            "",
            "",
            "",
            "",
            "Cargos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoCte),
          ],
          [
            "",
            "",
            "",
            "",
            "Abonos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoCte),
          ],
          [
            "",
            "",
            "",
            "",
            "Saldo",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ],
        ],
        showFoot: "lastPage",
      });
      pdfFooter(doc);
      doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
    }else{
      const data = movimientos.map((a) => {
        if (
          (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
        ) {
          totalCargosEdoCte = totalCargosEdoCte + a.cargo;
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
          saldoParcial = saldoParcial + a.cargo - a.abono;
          const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo);
          const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono);
          var saldoParcialFormato =
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial);
          return [
            a.fecha,
            a.descripcion,
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo - a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ];
        }
      });
      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });
      const doc = new jsPDF();
      const startY2 = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
      doc.autoTable({
        ...pdfTableStyles(),
        head: [
          [
            "Fecha",
            "Descripcion",
            "Cargos",
            "Abonos",
            "Saldo",
            "Saldo Total",
          ],
        ],
        body: dataPDFLimpia,
        startY: startY2,
        foot: [
          [
            "",
            "",
            "",
            "",
            "Cargos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoCte),
          ],
          [
            "",
            "",
            "",
            "",
            "Abonos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoCte),
          ],
          [
            "",
            "",
            "",
            "",
            "Saldo",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ],
        ],
        showFoot: "lastPage",
      });
      pdfFooter(doc);
      doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
    }
    



  }


  let totalCargos = 0
  let totalAbonos = 0
  let totalSaldo = 0

  let saldoParcialTabla = saldoInicial
  let totalCargosEdo = 0
  let totalAbonosEdo = 0
  let totalSaldoEdo = 0
 
  let totalCargos2 = 0
  let totalAbonos2 = 0
  let totalSaldo2 = 0

  let saldoParcialTablaRelacionado = 0;
  let totalCargosEdoRelacionado = 0;
  let totalAbonosEdoRelacionado = 0;

  return (
    <>
      <Header />
      {user.menu_usuarios ? (
        <div className="card container col-sm-11">

          {/* ── Page header ─────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcFileInvoiceDollar style={{ marginRight: 8, color: "#3b82f6" }} />
                Estado de Cuenta
              </h3>
              <p className="page-subtitle">Resumen de cargos, abonos y saldos por cliente</p>
            </div>
            <div className="page-actions">
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>
                  <IcPdf style={{ marginRight: 4 }} /> PDF
                </Button>
                <Button size="sm" color="info" onClick={toggleMail}>
                  <IcAt style={{ marginRight: 4 }} /> eMail
                </Button>
                <Button size="sm" color="primary" onClick={excel}>
                  <IcExcel style={{ marginRight: 4 }} /> Excel
                </Button>
              </ButtonGroup>
            </div>
          </div>

          {/* ── Summary cards ──────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              { label: "Clientes activos",  value: summaryStats.clientes,    sub: `${summaryStats.conDeuda} con saldo pendiente`, icon: "fas fa-users",         color: "#8b5cf6", bg: "#f5f3ff" },
              { label: "Cartera pendiente", value: summaryStats.totalSaldo,  sub: "Saldo por cobrar",                            icon: "fas fa-hourglass-half", color: "#f59e0b", bg: "#fffbeb" },
              { label: "Eficiencia global", value: `${summaryStats.cobPct}%`,sub: "Cobranza acumulada",                          icon: "fas fa-chart-line",     color: summaryStats.cobColor, bg: summaryStats.cobBg },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", borderTop: `3px solid ${card.color}`, display: "flex", alignItems: "center", gap: 14, height: "100%" }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: card.bg, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FaIcon cls={card.icon} size={20} style={{ color: card.color }} />
                  </div>
                  <div>
                    <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>{card.value}</div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{card.label}</div>
                    <div style={{ fontSize: "0.72rem", color: card.color, fontWeight: 600, marginTop: 2 }}>{card.sub}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Filters ─────────────────────────────────────────────────── */}
          <div className="filter-bar">
            <div>
              <Label>Empresa</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 160 }}
                value={selectedEmpresa}
                required
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="ExceptoSistemify">Excepto Sistemify</option>
                <option value="Lynqro">Lynqro</option>
                <option value="Lynqro 2">Lynqro 2</option>
                <option value="Sistemify">Sistemify</option>
              </Input>
            </div>
            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </div>
            <div>
              <Label>Estado de pago</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={estadoPago}
                onChange={(e) => {
                  setEstadoPago(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Pendientes">Pendientes</option>
                <option value="Liquidados">Liquidados</option>
              </Input>
            </div>
          </div>

          {/* ── Pagination + Search ──────────────────────────────────────── */}
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                totalCargos = totalCargos + p.cargos
                totalAbonos = totalAbonos + p.abonos
                totalSaldo = totalSaldo + p.saldo
                {
                  return (
                    <tr>
                      <td> {p.nombre_comercial}</td>
                      <td> {p.contacto}</td>
                      <td> {p.empresa}</td>
                      <td> {p.ramo}</td>
                      <td>{"$"+new Intl.NumberFormat("en-US").format(p.cargos)}</td>
                      <td>{"$"+new Intl.NumberFormat("en-US").format(p.abonos)}</td>
                      <td>{"$"+new Intl.NumberFormat("en-US").format(p.saldo)}</td>
                      <td>
                        <Button
                          color="info"
                          size="sm"
                          onClick={() => jalaMov(p._id, p.cliente, p.saldo)}
                          title="Estado de cuenta"
                        >
                          <IcFileAlt />
                        </Button>{" "}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => jalaMovRel(p._id, p.cliente, p.saldo, p.email)}
                          title="Estado de cuenta relacionado"
                        >
                          <IcFileAlt />
                        </Button>
                      </td>
                      <td>
                        <Button
                          color="success"
                          size="sm"
                          onClick={() => abrirPago(p._id, p.cliente, p.saldo)}
                          title="Capturar pago"
                          disabled={p.saldo <= 0}
                        >
                          <IcDollar />
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">Totales</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalCargos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalSaldo)}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xxl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
            <ButtonGroup>
              <Button size="sm" color="danger" onClick={PDFOC}>
                <IcPdf style={{ marginRight: 4 }} /> PDF
              </Button>
              <Button size="sm" color="info" onClick={toggleMail2}>
                <IcAt style={{ marginRight: 4 }} /> eMail
              </Button>
              <Button size="sm" color="primary" onClick={excelFOC}>
                <IcExcel style={{ marginRight: 4 }} /> Excel
              </Button>
            </ButtonGroup>
            <div>
              <Label style={{ display: "block" }}>Desde fecha</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </div>
            <div style={{ marginLeft: "auto" }}>
              <span style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 600, display: "block" }}>Saldo</span>
              <Badge color="danger" className="BadgeSize badge-pill" style={{ fontSize: "0.95rem" }}>
                {"$" + new Intl.NumberFormat("en-US").format(saldo)}
              </Badge>
            </div>
          </div>
          <div className="card container">
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                  <thead>
                      <tr align="center">
                        <th align="left">Fecha</th>
                        <th>Movimiento</th>
                        <th>Numero</th>
                        <th>Cargos</th>
                        <th>Abonos</th>
                        <th>Saldo</th>
                      </tr>
                      </thead>
                      <tbody>
                        {selectedFechaInicio?(
                              <tr>
                              <td align="center">NA</td>
                              <td align="center">Saldo Anterior</td>
                              <td align="center">NA</td>
                              <td align="center">NA</td>
                              <td align="center">NA</td>
                              <td align="center">{"$" + new Intl.NumberFormat("en-US").format(saldoInicial)}</td>
                            </tr>
                        ):undefined}
                      {movimientos
                      .map((c) => {
                        if(
                          (selectedFechaInicio == "" || selectedFechaInicio <= c.fecha)
                          ){
                        saldoParcialTabla = saldoParcialTabla + c.cargo - c.abono
                        totalCargosEdo = totalCargosEdo + c.cargo
                        totalAbonosEdo = totalAbonosEdo + c.abono
                        totalSaldoEdo = totalCargosEdo - totalAbonosEdo
                        const esAnticipo = c.movimiento === "Anticipo";
                        return (
                          <tr style={esAnticipo ? { backgroundColor: "#eff6ff" } : undefined}>
                            <td align="center">{c.fecha}</td>
                           <td align="center">
                             {esAnticipo ? (
                               <span style={{ color: "#6366f1", fontWeight: 700 }}>
                                 <IcFileInvoiceDollar style={{ marginRight: 4, fontSize: 11 }} />
                                 {c.movimiento}
                               </span>
                             ) : c.movimiento}
                           </td>
                           <td align="center">{c.numero}</td>
                           <td align="center">{"$" + new Intl.NumberFormat("en-US").format(c.cargo)}</td>
                           <td align="center" style={esAnticipo ? { color: "#6366f1", fontWeight: 700 } : undefined}>
                             {"$" + new Intl.NumberFormat("en-US").format(c.abono)}
                           </td>
                           <td align="center">{"$" + new Intl.NumberFormat("en-US").format(saldoParcialTabla)}</td>
                         </tr>
                        )
                      }
                      })}

                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td td className="negrita" >Saldo Anterior</td>
                        <td td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(saldoInicial)}</td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td td className="negrita" >Cargos del Periodo</td>
                        <td td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(totalCargosEdo)}</td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td td className="negrita" >Abonos del Periodo</td>
                        <td td className="negrita" align="center">{"$-" + new Intl.NumberFormat("en-US").format(totalAbonosEdo)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td td className="negrita" >Saldo Actual</td>
                        <td td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(saldoParcialTabla)}</td>
                      </tr>
                    </tbody>
                  </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Estado de Cuenta</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <Modal size="sm" isOpen={modalMail2} toggle={toggleMail2}>
            <ModalHeader toggle={toggleMail2}>
              <h4>Enviar Estado de Cuenta</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={emailFOC}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          

{/* Estado de Cuenta 2 */}
<Modal size="xxl" isOpen={modalCargos} toggle={toggleCargos}>
        <ModalHeader toggle={toggleCargos}>
          <h4>Cargos de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
            <div style={{ marginLeft: "auto" }}>
              <span style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 600, display: "block" }}>Saldo</span>
              <Badge color="danger" className="BadgeSize badge-pill" style={{ fontSize: "0.95rem" }}>
                {"$" + new Intl.NumberFormat("en-US").format(saldo)}
              </Badge>
            </div>
          </div>
          <div className="card container">
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                  <thead>
                      <tr align="center">
                        <th align="left">Fecha</th>
                        <th>Descripcion</th>
                        <th>Cargos</th>
                        <th>Abonos</th>
                        <th>Saldo</th>
                      </tr>
                      </thead>
                      <tbody>
                      {cargos
                      .map((c) => {
                        totalCargos2 = totalCargos2 + c.cargos
                        totalAbonos2 = totalAbonos2 + c.abonos
                        totalSaldo2 = totalCargos2 - totalAbonos2
                        return (
                          <tr>
                            <td align="center">{c.fecha}</td>
                           <td align="center">{c.descripcion}</td>
                           <td align="center">{"$" + new Intl.NumberFormat("en-US").format(c.importe)}</td>
                           <td align="center">{"$" + new Intl.NumberFormat("en-US").format(c.abonos)}</td>
                           <td align="center">{"$" + new Intl.NumberFormat("en-US").format(c.saldo)}</td>
                         </tr>
                        )
                      })}

                      <tr>
                        <td></td>
                        <td className="negrita" align="center">Totales</td>
                        <td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(totalCargos)}</td>
                        <td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                        <td className="negrita" align="center">{"$" + new Intl.NumberFormat("en-US").format(totalSaldo)}</td>
                      </tr>

                    </tbody>
                  </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggleCargos}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xxl" isOpen={modalRelacionado} toggle={toggleRelacionado}>
        <ModalHeader toggle={toggleRelacionado}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
            <Button size="sm" color="danger" onClick={PDFOCRelacionado}>
              <IcPdf style={{ marginRight: 4 }} /> PDF
            </Button>
            <div>
              <Label style={{ display: "block" }}>Filtrar</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={saldoFiltroRel}
                onChange={(e) => setSaldoFiltroRel(e.target.value)}
              >
                <option value="Pendientes">Pendientes</option>
                <option value="Todas">Todas</option>
              </Input>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <span style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 600, display: "block" }}>Saldo</span>
              <Badge color="danger" className="BadgeSize badge-pill" style={{ fontSize: "0.95rem" }}>
                {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(saldo)}
              </Badge>
            </div>
          </div>

          <div className="card container">
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr align="center">
                  <th align="left">Fecha</th>
                  <th>Descripcion</th>
                  <th>Cargos</th>
                  <th>Abonos</th>
                  <th>Saldo</th>
                  <th>Saldo Total</th>
                </tr>
              </thead>
              <tbody>
              {saldoFiltroRel == "Pendientes" ? (
                  <>
                {movimientos
                .sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
                .map((c) => {
                  if (c.saldo > 1) {
                    saldoParcialTablaRelacionado = saldoParcialTablaRelacionado + c.saldo;
                    totalCargosEdoRelacionado = totalCargosEdoRelacionado + c.cargo;
                    totalAbonosEdoRelacionado = totalAbonosEdoRelacionado + c.abono;
                    // totalSaldoEdoRelacionado = totalCargosEdoRelacionado - totalAbonosEdoRelacionado;

                      return (
                        // <tr style={{backgroundColor:"#ed8c8c"}}>
                          <tr>
                          <td align="center">{c.fecha}</td>
                          <td align="center">{c.descripcion}</td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.cargo)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.abono)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                c.saldo
                              )}
                          </td>

                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                saldoParcialTablaRelacionado
                              )}
                          </td>
                        </tr>
                      )
                  }}
                )}
                  </>

              ): (
                <>
              {movimientos
              .sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
              .map((c) => { 
                  saldoParcialTablaRelacionado = saldoParcialTablaRelacionado + c.saldo;
                  totalCargosEdoRelacionado = totalCargosEdoRelacionado + c.cargo;
                  totalAbonosEdoRelacionado = totalAbonosEdoRelacionado + c.abono;
                  // totalSaldoEdoRelacionado = totalCargosEdoRelacionado - totalAbonosEdoRelacionado;

                    return (
                      // <tr style={{backgroundColor:"#ed8c8c"}}>
                        <tr>
                        <td align="center">{c.fecha}</td>
                        <td align="center">{c.descripcion}</td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.cargo)}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.abono)}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                              c.saldo
                            )}
                        </td>

                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                              saldoParcialTablaRelacionado
                            )}
                        </td>
                      </tr>
                    )
                }
              )}
                </>

              )}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    Cargos
                  </td>
                  <td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoRelacionado)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    Abonos
                  </td>
                  <td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoRelacionado)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    Saldo Actual
                  </td>
                  <td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcialTabla)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggleRelacionado}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {/* ── Modal Capturar Pago ── */}
      <Modal size="xl" isOpen={modalPago} toggle={togglePago}>
        <ModalHeader toggle={togglePago}>
          <h4>Capturar Pago — {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          {pagoLoading ? (
            <div className="text-center py-4">
              <Spinner style={{ width: "2rem", height: "2rem" }} />
            </div>
          ) : (
            <Form>
              <FormGroup>
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={pagoFecha}
                      onChange={(e) => setPagoFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Concepto</Label>
                    <Input
                      type="select"
                      value={pagoConcepto}
                      onChange={(e) => setPagoConcepto(e.target.value)}
                    >
                      <option value="Abono">Abono</option>
                      <option value="Bonificacion">Bonificación</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Forma de Pago</Label>
                    <Input
                      type="select"
                      value={pagoFormaPago}
                      onChange={(e) => setPagoFormaPago(e.target.value)}
                    >
                      <option value="Efectivo">Efectivo</option>
                      <option value="Transfer">Transfer</option>
                      <option value="TDC">TDC</option>
                      <option value="Bonificacion">Bonificación</option>
                    </Input>
                  </Col>
                  <Col md={3} className="d-flex align-items-end justify-content-end">
                    <h4>
                      Total Pago{"  "}
                      <Badge color="danger" className="BadgeSize badge-pill">
                        {"$" + new Intl.NumberFormat("en-US").format(pagoTotal)}
                      </Badge>
                    </h4>
                  </Col>
                </Row>
              </FormGroup>
              <br />
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Nota</th>
                    <th>Total</th>
                    <th>Abonos</th>
                    <th>Saldo</th>
                    <th>Importe</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {pagoInputFields.map((a) => (
                    <tr key={a.id}>
                      <td>{a.fecha}</td>
                      <td>{a.nota}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.total_general)}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.abonos)}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.saldo)}</td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          name="importe"
                          value={a.importe}
                          onChange={(e) => handlePagoImporte(a.id, e)}
                        />
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="text"
                          name="observaciones"
                          value={a.observaciones}
                          onChange={(e) => handlePagoObs(a.id, e)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={savePago} disabled={pagoLoading}>
            Registrar Pago
          </Button>
          <Button color="secondary" onClick={togglePago}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default EstadoCuenta;
